<template>
  <main id="js-page-content" role="main" class="page-content">
    <div class="row">
      <div class="subheader col-6">
        <h1 class="subheader-title">個人目標マスタ一覧</h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div class="subheader-block ml-auto demo">
        <!-- <button
          type="button"
          @click="dl()"
          :disabled="btnDisable"
          class="btn btn-success waves-effect waves-themed"
        >
          <span class="fal fa-download mr-1"></span>Excel出力
        </button> -->
        <button
          type="button"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
          @click="$router.push('/personalGoalEdit')"
        >
          <span class="fal fa-check mr-1"></span>追加
        </button>
      </div>
    </div>
    <!-- Your main content goes below here: -->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>検索条件</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <div class="row">
                <div class="col-md-1 contTitle">期</div>
                <div class="col-md-5 contCnt selectedClear">
                  <vSelect
                    :options="opGoal"
                    v-model="domYear"
                    :reduce="(label:any) => label.code"
                  ></vSelect>
                </div>
                <div class="col-md-1 contTitle">社員名</div>
                <div class="col-md-5 contCnt selectedClear">
                  <!-- <vSelect :options="items4staffs"></vSelect> -->
                  <vSelect
                    :options="delegate4list.items4staffsSortNum"
                    v-model="domStaffId"
                    :reduce="(label:any) => label.c_staff_id"
                    label="c_staff_name"
                  ></vSelect>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">部署</div>
                <div class="col-md-5 contCnt selectedClear">
                  <vSelect
                    :options="op4StaffDepart"
                    v-model="domDepart"
                    :reduce="(label:any) => label.code"
                  ></vSelect>
                </div>
                <div class="col-md-1 contTitle">拠点</div>
                <div class="col-md-5 contCnt selectedClear">
                  <!-- <vSelect :options="op4BranchId"></vSelect> -->
                  <vSelect
                    :options="delegate4list.items4Branch"
                    v-model="domBranchId"
                    :reduce="(label:any) => label.c_branch_id"
                    label="c_branch_name"
                  ></vSelect>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <button
                  type="button"
                  class="btn btn-primary waves-effect waves-themed btn-search mx-auto"
                  :disabled="btnDisable"
                  @click="getlist(1)"
                >
                  検索
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>条件結果</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content">
              <!-- good table start -->
              <vue-good-table
                mode="remote"
                v-on:page-change="onPageChange"
                v-on:sort-change="onSortChange"
                :columns="columns"
                :rows="delegate.exitems"
                :sort-options="{
                  enabled: false,
                }"
                :pagination-options="{
                  enabled: false,
                  // perPageDropdownEnabled: false,
                  // jumpFirstOrLast: false,
                  // nextLabel: '次へ',
                  // prevLabel: '前へ',
                  // mode: 'pages',
                  // ofLabel: '/',
                  // pageLabel: '',
                }"
                :totalRows="delegate.pager.maxcount"
              >
                <template #table-row="props">
                  <!-- //------- -->
                  <div
                    v-if="props.column.field == 'btnDet'"
                    class="gtablecell btnDetCell"
                  >
                    <button
                      type="button"
                      class="btn btn-xs btn-primary waves-effect waves-themed"
                      :disabled="btnDisable"
                      @click="
                        goTo(
                          '/personalGoalEdit?id=' + props.row.c_goal_id,
                          $event
                        )
                      "
                    >
                      詳細
                    </button>
                  </div>
                  <!-- //------- -->
                  <div
                    v-else-if="props.column.field == 'c_staff_depart'"
                    class="gtablecell"
                  >
                    <span v-if="props.row.c_staff_depart == 1">営業部</span>
                    <span v-if="props.row.c_staff_depart == 2">経営企画室</span>
                  </div>
                  <!-- //------- -->
                  <div
                    v-else-if="props.column.field == 'c_goal_earnings'"
                    class="gtablecell"
                  >
                    {{
                      props.formattedRow[props.column.field].toLocaleString(
                        "ja-JP"
                      )
                    }}
                  </div>
                  <!-- //------- -->
                  <div
                    v-else-if="props.column.field == 'c_goal_gross'"
                    class="gtablecell"
                  >
                    {{
                      props.formattedRow[props.column.field].toLocaleString(
                        "ja-JP"
                      )
                    }}
                  </div>
                  <!-- //------- -->
                  <div v-else class="gtablecell">
                    {{ props.formattedRow[props.column.field] }}
                  </div>
                  <!-- //------- -->
                </template>
              </vue-good-table>
              <!-- good table end -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- エラー確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_errorConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalErrorConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="closeModal4ErrorConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            確認
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Cl_common } from "@/functions/Cl_common";
import { CONST_LIST_DEFO_COUNT } from "@/constants/constant";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "vue-good-table-next/dist/vue-good-table-next.css";
import { VueGoodTable } from "vue-good-table-next";
import { DtoGoalsGetReqImple } from "furukawa-common/src/common/dto/DtoGoalsGetReqImple";
import { DtoGoalsGetResImple } from "furukawa-common/src/common/dto/DtoGoalsGetResImple";
import { Cl_goal } from "@/functions/Cl_goal";
import { DtoMastersgetReq } from "furukawa-common/src/common/dto/DtoMastersGetReq";
import { Cl_master } from "@/functions/Cl_master";
import { DtoMastersGetRes } from "furukawa-common/src/common/dto/DtoMastersGetRes";
import { CONST_OP_STAFFDEPART } from "furukawa-common/src/common/constant/Constants";
import { CommonDate4FU } from "furukawa-common/src/common/function/CommonDate4FU";

@Options({
  components: {
    vSelect,
    VueGoodTable,
    Mo_modal_alert,
  },
})
export default class PersonalGoalList extends Vue {
  /**
   * パフォーマンス問題の解決案としてテスト的に実装中
   * 残課題：グローバルなメソッドとして宣言して、どこからでも呼び出せるようにしたい
   * 　　　　色々なパターンでも問題ないかの検証
   * @param url
   * @param event
   */
  goTo(url: string, event?: MouseEvent) {
    if (event && (event.ctrlKey || event.metaKey)) {
      window.open(url);
    } else {
      this.$router.push(url);
    }
  }
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  delegate = new DtoGoalsGetResImple();
  delegate4list = new DtoMastersGetRes();
  // domYear = { label: "" };
  domYear = "";
  domDepart = "";
  domBranchId = "";
  domStaffId = "";
  //ボタン制御用
  btnDisable = false;

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  opGoal = CommonDate4FU.getFiscalYearOptionList();
  op4StaffDepart = CONST_OP_STAFFDEPART;

  columns = [
    {
      label: "詳細",
      field: "btnDet",
      thClass: "text-center",
      tdClass: "text-center",
      width: "10%",
    },
    {
      label: "期",
      field: "c_goal_year",
      thClass: "text-center",
      width: "10%",
    },
    {
      label: "社員番号",
      field: "c_staff_id",
      thClass: "text-center",
    },
    {
      label: "社員名",
      field: "c_staff_name",
      thClass: "text-center",
    },
    {
      label: "部署",
      field: "c_staff_depart",
      thClass: "text-center",
    },
    {
      label: "拠点",
      field: "c_branch_name",
      thClass: "text-center",
    },
    {
      label: "売上目標",
      field: "c_goal_earnings",
      thClass: "text-center",
      tdClass: "text-right",
    },
    {
      label: "粗利目標",
      field: "c_goal_gross",
      thClass: "text-center",
      tdClass: "text-right",
    },
  ];

  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4ModalErrorConf = "";

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    await this.getlist(1);
    await this.getMastersList();
  }
  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   *Masters取得用
   */
  async getMastersList() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行社員マスタ取得");

      //準備
      //-------
      let dtoMaster = new DtoMastersgetReq();

      //検索選択肢用
      dtoMaster.getStaff4sortNum = 1;
      dtoMaster.delFlag4Staff4sortNum = 1;
      // dtoMaster.getStaff = 1;
      // dtoMaster.delFlag4staff = 0;

      dtoMaster.getBranch = 1;
      dtoMaster.delFlag4Branch = 0;

      //API実行
      //-------
      this.delegate4list = await Cl_master.get(dtoMaster);

      //レスポンス処理
      //-------
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました"; //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      this.delegate4list = new DtoMastersGetRes();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * 一覧データを読み込む
   */
  async getlist(currentPage: number) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoGoalsGetReqImple();

      //検索条件設定
      // dto.pager.count = CONST_LIST_DEFO_COUNT;
      dto.pager.count = 9999;
      dto.pager.cursor = currentPage;

      // if (
      //   this.domYear != null &&
      //   this.domYear.label != null &&
      //   this.domYear.label != ""
      // ) {
      //   dto.year = Number(this.domYear.label);
      // }

      if (this.domYear != "" && this.domYear != null)
        dto.year = Number(this.domYear);

      if (this.domStaffId != "" && this.domStaffId != null)
        dto.staffId = this.domStaffId;

      if (this.domBranchId != "" && this.domBranchId != null)
        dto.branchId = this.domBranchId;

      if (this.domDepart != "" && this.domDepart != null)
        dto.depertId = this.domDepart;

      //API実行
      //-------
      this.delegate = await Cl_goal.getList(dto);

      //レスポンス処理
      //-------
      Cl_common.logger("結果");
      Cl_common.logger(this.delegate);
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      //エラー発生で一覧を初期化
      this.delegate = new DtoGoalsGetResImple();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * ファイルをダウンロードする
   */
  async dl() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      // let dto = new DtoFileMastersGetReqImple();
      // dto.type = "SalesTargetMaster";
      // if (
      //   this.domYear != null &&
      //   this.domYear.label != null &&
      //   this.domYear.label != ""
      // ) {
      //   dto.year = Number(this.domYear.label);
      // }

      //API実行
      //-------
      // const res = await Cl_filemaster.get(dto);

      //レスポンス処理
      //-------
      // location.href = res.url;
      //window.open(res.url, "_blank");
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  async moveDet(id: string) {
    //詳細ページに移動
    this.$router.push("/personalGoalEdit?id=" + id);
  }

  /**
   * ページ更新時の処理
   * @param params
   */
  async onPageChange(params: any) {
    //テーブル更新処理
    await this.getlist(params.currentPage);
  }

  /**
   * ソート変更時の処理
   * @param params
   */
  async onSortChange(params: any) {
    //テーブル更新処理
  }

  totalEarnings(props: any) {
    return (
      props.row.c_goal_earnings_1 +
      props.row.c_goal_earnings_2 +
      props.row.c_goal_earnings_3 +
      props.row.c_goal_earnings_4 +
      props.row.c_goal_earnings_5 +
      props.row.c_goal_earnings_6 +
      props.row.c_goal_earnings_7 +
      props.row.c_goal_earnings_8 +
      props.row.c_goal_earnings_9 +
      props.row.c_goal_earnings_10 +
      props.row.c_goal_earnings_11 +
      props.row.c_goal_earnings_12
    ).toLocaleString();
  }

  totalGross(props: any) {
    return (
      props.row.c_goal_gross_1 +
      props.row.c_goal_gross_2 +
      props.row.c_goal_gross_3 +
      props.row.c_goal_gross_4 +
      props.row.c_goal_gross_5 +
      props.row.c_goal_gross_6 +
      props.row.c_goal_gross_7 +
      props.row.c_goal_gross_8 +
      props.row.c_goal_gross_9 +
      props.row.c_goal_gross_10 +
      props.row.c_goal_gross_11 +
      props.row.c_goal_gross_12
    ).toLocaleString();
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
  async closeModal4ErrorConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_errorConf;
    modal.closeModal();
  }
}
</script>
